import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import home from '@/views/home'

Vue.use(Router)
// 把准备好路由组件注册到路由里
export default new Router({
  routes: [
    {
      path: '/hello',
      name: 'HelloWorld',
      component: HelloWorld
    },
    // {
    //   path: '/index',
    //   component: () =>
    //     import("../views/index.vue")
    // },
    {
      path: '/',
      component: home,
      redirect:'/index',
      children:[
        {
          path: 'index',
          props: true,
          component: () =>
            import("../views/index.vue")
        },
        {
          path: '/cscp',
          component: () =>
          import("../views/cscp")
        },
        {
          path: '/cpcp',
          component: () =>
          import("../views/cpcp")
        },
        {
          path: '/sound',
          component: () =>
          import("../views/sound")
        },
        {
          path: '/robot',
          component: () =>
          import("../views/robot")
        },
        {
          path: '/gywm',
          component: () =>
            import("../views/gywm")
        },
        {
          path: '/csal',
          component: () =>
            import("../views/csal")
        },
        {
          path: '/khal',
          component: () =>
            import("../views/khal")
        },
        {
          path: '/lxwm',
          component: () =>
            import("../views/lxwm")
        },
      ]
    },

    // { path: '/views/home', component: home},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js